import { z } from "zod";

import { defaultUrl, urlSchema } from "../shared";
import { customFieldSchema, deminimalizeCustomFields, minimalCustomFieldSchema } from "./custom";

// Schema
export const basicsSchema = z.object({
  name: z.string().describe("leave '' if not provided"),
  headline: z.string().describe("leave '' if not provided"),
  email: z.string().describe("leave '' if not provided"),
  phone: z.string().describe("leave '' if not provided"),
  location: z.string().describe("leave '' if not provided"),
  url: urlSchema,
  customFields: z.array(customFieldSchema),
  picture: z.object({
    url: z.string(),
    size: z.number().default(64),
    aspectRatio: z.number().default(1),
    borderRadius: z.number().default(0),
    effects: z.object({
      hidden: z.boolean().default(false),
      border: z.boolean().default(false),
      grayscale: z.boolean().default(false),
    }),
  }),
});

export const minimalBasicsSchema = basicsSchema
  .pick({
    name: true,
    headline: true,
    email: true,
    phone: true,
    location: true,
  })
  .extend({
    customFields: z
      .array(minimalCustomFieldSchema)
      .describe("Custom information, like social media, portfolio, etc."),
  });

// Type
export type Basics = z.infer<typeof basicsSchema>;
export type MinimalBasics = z.infer<typeof minimalBasicsSchema>;
// Defaults
export const defaultBasics: Basics = {
  name: "",
  headline: "",
  email: "",
  phone: "",
  location: "",
  url: defaultUrl,
  customFields: [],
  picture: {
    url: "",
    size: 64,
    aspectRatio: 1,
    borderRadius: 0,
    effects: {
      hidden: false,
      border: false,
      grayscale: false,
    },
  },
};

export const deminimalizeBasics = (basics: MinimalBasics): Basics => {
  return {
    ...defaultBasics,
    ...basics,
    customFields: deminimalizeCustomFields(basics.customFields),
  };
};

export * from "./custom";
